import styled from '@emotion/styled';

// Got to add a borderBottom of 1 px to avoid a strange white border on print
export const BaseLayout = styled.div`
  width: 200mm;
  height: 287mm;
  margin: 0;
  padding: 0;
  box-sizing: content-box;
  padding-left: 10mm;
  background-color: white;
  page-break-before: always;
`;

export const LastPageLayout = styled(BaseLayout)`
  padding-left: 0;
  width: 210mm;
  height: 297mm;
  * {
    color: black;
  }
`;
export const CoverLayout = styled(BaseLayout)`
  background-color: var(--PURPLE);
  padding-top: 10mm;
  border-bottom: 1px solid var(--PURPLE);
`;

export const PageLayout = styled(BaseLayout)`
  height: 297.1mm;
  border-left: 1px solid white;
`;
export const CoverContentLayout = styled.div`
  border-radius: 20px;
  background-color: white;
  width: 190mm;
  height: 277mm;
  display: flex;
  flex-direction: column;
`;

interface ContentLayoutProps {
  color?: string;
}

export const ContentLayout = styled.div<ContentLayoutProps>`
  box-sizing: border-box;
  border-right: ${({ color }) =>
    color ? `1cm solid ${color}` : '1cm solid var(--PURPLE)'};
  width: 200mm;
  background-color: white;
  min-height: 262mm;
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

interface LogoProps {
  maxWidth?: string;
  maxHeight?: string;
}

export const Logo = styled.img<LogoProps>`
  max-width: ${({ maxWidth }) => maxWidth || '200px'};
  max-height: ${({ maxHeight }) => maxHeight || '80px'};
`;

export type TextProps = {
  fontSize: string;
  color?: string;
  condensed?: boolean;
  backgroundColor?: string;
  fontWeight?: string;
  textAlign?: string;
  lineHeight?: string;
};

export const Text = styled.div`
  font-family: 'Epilogue', sans-serif;
  font-size: ${({ fontSize }: TextProps) => fontSize};
  font-weight: ${({ fontWeight }: TextProps) => fontWeight || 'normal'};
  color: ${({ color }: TextProps) => color || 'black'};
  line-height: ${({ condensed, lineHeight }: TextProps) =>
    lineHeight ? lineHeight : condensed ? '0.85' : '1'};
  text-align: ${({ textAlign }: TextProps) => textAlign || 'center'};
  text-wrap: wrap;
`;
